import PropTypes from 'prop-types';
import React from 'react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import './ComboButton.scss';

export default class ComboButton extends React.PureComponent {
  render() {
    const {
      options,
      className = '',
      btnClass = '',
      secondaryAriaLabel = '',
      handleClick,
      labelledById,
      label,
      right = true,
      isLoading = false,
      ButtonTag = DefaultButton,
      children,
      disabled,
      dataKey = ''
    } = this.props;

    const [primary, ...secondary] = options;

    return (
      <div className={`cp-combo-btn btn-group ${className}`}>
        <ButtonTag
          disabled={disabled}
          className={btnClass}
          isLoading={isLoading}
          handleClick={() => handleClick(primary.value)}
          data-key={dataKey}
        >
          {primary.label}
          {children}
        </ButtonTag>
        <Dropdown
          dataKey="combo-button-dropdown"
          ButtonTag={ButtonTag}
          right={right}
          selected={<ScreenReaderMessage>{secondaryAriaLabel}</ScreenReaderMessage>}
          disableMobile
          disabled={disabled || isLoading}
          options={secondary}
          handleSelect={handleClick}
          labelledById={labelledById}
          labelLocalizedText={label}
          descriptionLocalizedText={label}
        />
      </div>
    );
  }
}

ComboButton.displayName = 'ComboButton';

ComboButton.propTypes = {
  children: childrenShape,
  ButtonTag: PropTypes.func,
  right: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.any
    })
  ).isRequired,
  btnClass: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  labelledById: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  secondaryAriaLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string.isRequired]),
  dataKey: PropTypes.string
};
